import { EpModal } from '@/components/EpModal';
import { useTranslation as t } from '@/hooks/useTranslation';

import { useHospitalStore, useTranslationStore } from '../stores';

import { userService } from '../services/userService';
import { IGetStampsResponse } from '@/services/stampsService';

import Parse from 'html-react-parser';
import { stampsService } from '../services/stampsService';
import { hideModal } from '../components/EpModal';

export default function PatientSafetySealModal({
  stamp,
}: {
  stamp: IGetStampsResponse;
}) {
  const { translations } = useTranslationStore((state) => state);
  const { hospitalInfo } = useHospitalStore((state) => state);

  const { getHospitalInfo } = userService;
  const { data: contactInfo } = getHospitalInfo(
    hospitalInfo ? hospitalInfo.HospitalId : '',
    !!hospitalInfo?.HospitalId,
  );

  const { PostViewStamp } = stampsService;

  const { mutate: fetchViewStamp } = PostViewStamp({
    hospitalId: hospitalInfo?.HospitalId || '',
    categoryId: process.env.NEXT_PUBLIC_PATIENTY_SAFETY_STAMP_CATEGORY_ID || '',
    year: stamp?.year || '',
  });

  return (
    <EpModal
      key={`modal--sp-seal-1`}
      modalId={`modal--sp-seal-id`}
      modalTitle={t(translations['global'], 'Patient Safety Certificate')}
      modalType="default"
      modalSize="md"
      modalButtonList={[
        {
          buttonId: `button--modal-sp-seal-cancel`,
          buttonLeftIconName: 'SolidTimes',
          buttonSize: 'sm',
          buttonText: t(translations['global'], 'OK, I agree.'),
          isCloseButton: false,
          buttonType: 'secondary-outline',
          buttonOnClickFunc: () => {
            if (stamp) {
              fetchViewStamp({
                hospitalId: hospitalInfo?.HospitalId || '',
                categoryId:
                  process.env.NEXT_PUBLIC_PATIENTY_SAFETY_STAMP_CATEGORY_ID ||
                  '',
                year: stamp.year,
              });
              hideModal(`modal--sp-seal-id`);
            }
          },
        },
        {
          buttonId: `button--modal-sp-seal-cancel`,
          buttonLeftIconName: 'SolidBookReader',
          buttonSize: 'sm',
          buttonText: t(translations['global'], 'Learn More'),
          isCloseButton: false,
          buttonType: 'secondary-outline',
          buttonOnClickFunc: () => {
            window.open(
              'https://www.epimedsolutions.com/certificacoes/',
              '_blank',
            );
          },
        },
      ]}
    >
      <div>
        <div
          className="ep-modal__content-body-title"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            // width: '100%',
            marginBottom: '10px',
          }}
        >
          <img
            src={process.env.NEXT_PUBLIC_BASE_API_URL_CDN + stamp?.img}
            alt={t(translations['global'], 'Patient Safety Certificate')}
          />
        </div>

        <h3 style={{ marginBottom: '16px' }}>
          {t(translations['global'], 'Congratulations!')}{' '}
          {contactInfo && contactInfo.hospitalName}
        </h3>

        <p className="ep-modal__content-body-long-desc">
          {t(
            translations['global'],
            'It is with great satisfaction that we inform you that your institution has won the Patient Safety Certificate, issued by Epimed Solutions in partnership with IBSP.',
          )}
        </p>

        <p className="ep-modal__content-body-long-desc">
          {Parse(
            t(
              translations['global'],
              'The Patient Safety Certificate is awarded to health institutions across the country that meet the criteria for promoting good practices for Patient Safety when reporting, classifying, investigating and dealing with incidents and adverse events, according to the assessments generated. by the Epimed Monitor Patient Safety system, and is valid for 1 year.',
            ),
          )}
        </p>
      </div>
    </EpModal>
  );
}
